import { render, staticRenderFns } from "./ProductConfigurationDynamicDepotModal.vue?vue&type=template&id=25bac3f9"
import script from "./ProductConfigurationDynamicDepotModal.vue?vue&type=script&lang=js"
export * from "./ProductConfigurationDynamicDepotModal.vue?vue&type=script&lang=js"
import style0 from "./ProductConfigurationDynamicDepotModal.vue?vue&type=style&index=0&id=25bac3f9&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_j7knk6mol3vthgvrc443rvn57u/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports